// assets
import { LoginOutlined, ProfileOutlined, FolderViewOutlined, ImportOutlined, ApartmentOutlined, BulbOutlined, SettingOutlined, BarChartOutlined } from '@ant-design/icons';

// icons
const icons = {
  FolderViewOutlined,
  ProfileOutlined, ImportOutlined, BulbOutlined, ApartmentOutlined, SettingOutlined, BarChartOutlined
};
// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //
let userRole = localStorage.getItem("role");
console.log(userRole);
const pages = {
  id: 'authentication',
  // title: 'Authentication',
  type: 'group',
  children: [
    {
      id: 'Presentation',
      title: 'Presentation',
      type: 'item',
      url: '/presentations',
      icon: icons.FolderViewOutlined,
    },
    {
      id: 'Templates',
      title: 'Templates',
      type: 'item',
      url: '/templates',
      icon: icons.ProfileOutlined,
    },
    {
      id: 'Component',
      title: 'Component',
      type: 'item',
      url: '/components',
      icon: icons.ApartmentOutlined,
    },
    {
      id: 'Imports',
      title: 'Imports',
      type: 'item',
      url: '/imports',
      icon: icons.ImportOutlined,
    },
    {
      id: 'Report',
      title: 'Report',
      type: 'item',
      url: '/dspreport',
      icon: icons.BarChartOutlined,
    },
    {
      id: 'NextConfigure',
      title: 'NEXT-DSP',
      type: 'item',
      url: '/next-presentations',
      icon: icons.ImportOutlined,
    },
    {
      id: 'MigrationDSP',
      title: 'Migration-DSP',
      type: 'item',
      url: '/migration-contents',
      icon: icons.ImportOutlined,
    },
    {
      id: 'userSettings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
    }
  ]
};

export default pages;
